export default {
  "content": "<title>Icons/Consolidated</title><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DFF5EE\" cx=\"24\" cy=\"24\" r=\"24\"/><path d=\"M41.923 15.618A1.003 1.003 0 0041 15h-9a1 1 0 100 2h6.586l-8.773 8.773 1.414 1.414L40 18.414V25a1 1 0 102 0v-9c0-.13-.026-.26-.077-.382M26.75 28.836l-6.793-6.793a.999.999 0 00-1.414 0l-11.25 11.25a.999.999 0 101.414 1.414L19.25 24.164l6.793 6.793a.999.999 0 001.414 0l.73-.73-1.415-1.413-.022.022zM12 12.414l25.456 25.457 1.414-1.414L13.414 11z\" fill=\"#5D2193\"/></g>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};